import {createAction} from 'typesafe-actions';

import * as Report from '../util/report';

export const clear = createAction('report/CLEAR', resolve => {
  return () => resolve();
});

export const set = createAction('report/ADD', resolve => {
  return (report: Report.ReportConfig) => resolve({report});
});
